import { render } from "./EditarCuenta.vue?vue&type=template&id=f5f13fb4"
import script from "./EditarCuenta.vue?vue&type=script&lang=js"
export * from "./EditarCuenta.vue?vue&type=script&lang=js"

import "./EditarCuenta.vue?vue&type=style&index=0&id=f5f13fb4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__